import { TableCell, type TableCellProps, type SxProps, type Theme } from "@mui/material";

const headerSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: 12,
  textTransform: "uppercase" as const,
  color: "text.secondary",
};

export function TableHeaderCell({ children, sx, ...rest }: TableCellProps) {
  return (
    <TableCell sx={sx ? ([headerSx, sx] as SxProps<Theme>) : headerSx} {...rest}>
      {children}
    </TableCell>
  );
}
